import { useState } from "react";
import { BottomNav, Header } from "../../components/laxmi/Chrome";
import { money, when } from "../../lib/api";

const FILTERS = ["All", "Deposit", "Withdrawal", "Bonus"];

export default function Transactions({ data, setPage }) {
  const [filter, setFilter] = useState("All");
  const visible = data.transactions.filter(tx => filter === "All" || tx.type === filter);
  return (
    <div className="screen">
      <Header title="Transaction history" onBack={() => setPage("account")} onBell={() => setPage("notifications")} />
      <div className="filter-row">{FILTERS.map(f => <button key={f} onClick={() => setFilter(f)} className={filter === f ? "selected" : ""} data-testid={`${f.toLowerCase()}-history-filter`}>{f}</button>)}</div>
      <div className="history-list">{visible.length ? visible.map(tx => {
        const out = tx.type === "Withdrawal" || tx.type === "Admin Debit";
        return (
          <div className="transaction" key={tx.transaction_id} data-testid={`transaction-${tx.transaction_id}`}>
            <div className="transaction-icon">{out ? "↑" : "↓"}</div>
            <div><b>{tx.type}</b><small>{tx.transaction_id} · {when(tx.created_at)}</small>
              {tx.utr && <small>UTR · {tx.utr}</small>}
              {tx.reason && <small className={tx.status === "Failed" ? "red" : ""}>{tx.reason}</small>}</div>
            <strong className={out ? "red" : "green"}>{out ? "-" : "+"}{money(tx.amount)}<small className={`tx-status ${tx.status}`}>{tx.status}</small></strong>
          </div>);
      }) : <div className="empty" data-testid="empty-history">No {filter.toLowerCase()} records</div>}</div>
      <BottomNav page="history" setPage={setPage} />
    </div>
  );
}
